module.exports = __webpack_public_path__ + "img/rectangleLoad.932ff890.svg";